import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Page404() {
  const { t } = useTranslation();

  return (
    <section className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-900 via-gray-900 to-black text-white p-6">
      <div className="max-w-4xl w-full flex flex-col md:flex-row items-center text-center md:text-left gap-10">
        {/* Illustration */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={`${process.env.REACT_APP_SMIK_API_BASEURL}/UI/empty-boxes.svg`}
            alt="Page not found"
            className="w-64 md:w-80 animate-bounce-slow"
          />
        </div>

        {/* Text Content */}
        <div className="w-full md:w-1/2">
          <h1 className="text-6xl font-bold text-red-500 mb-2">404</h1>
          <h2 className="text-2xl font-semibold mb-4">Oops! Page Not Found</h2>
          <p className="text-gray-300 mb-6">
            {t("Sorry, the page you're looking for doesn't exist or is still under construction.")}
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-white text-blue-900 font-semibold rounded-full shadow-md hover:bg-blue-600 hover:text-white transition"
          >
            ⬅ {t("Go to Home")}
          </Link>
        </div>
      </div>
    </section>
  );
}
